// extracted by mini-css-extract-plugin
export default {"accounts":"NetWorth_accounts__Ar7NV"};